const tab1 = document.querySelector('.tab_1');
const tab2 = document.querySelector('.tab_2');
const zoomIcon = document.querySelector('.tabla-content svg')
const ingredientsContainer = document.querySelector('.ingredients-analisis-container');
const pautaContainer = document.querySelector('.pauta-container');

// Función para cambiar las pestañas activas
function switchTabs() {
  // Alternar la clase 'active' entre las pestañas
  tab1.classList.toggle('active');
  tab2.classList.toggle('active');
  
  // Alternar la visibilidad de los contenedores de contenido
  ingredientsContainer.style.display = ingredientsContainer.style.display === 'none' ? 'flex' : 'none';
  pautaContainer.style.display = pautaContainer.style.display === 'none' ? 'flex' : 'none';
}

// Event listener para el clic en tab_1
tab1.addEventListener('click', function() {
  if (!tab1.classList.contains('active')) {
    switchTabs();
  }
});

// Event listener para el clic en tab_2
tab2.addEventListener('click', function() {
  if (!tab2.classList.contains('active')) {
    switchTabs();
  }
});

// zoomIcon.addEventListener('click', function() {
// })

